export enum CellType {
	Virtual = 'virtual', // ! only cell instances can be virtual!
	Concrete = 'concrete',
	Layout = 'layout',
	Repeat = 'repeat',
	Value = 'value',
	Null = 'null'
}